import axios, { AxiosResponse } from "axios";
import { FileData } from "../reducers";
import FormData from 'form-data';
import fs from 'fs';
import { createStudySession } from "./studySessions";
import { backendApi, backendApiDemo } from "../../../../common/apiService";

interface UploadResponse {
    filename: string;
    size: number;
}
// Update function to return a Promise
export async function s3UploadLinkRequest(
    file_size: number,
    file_name: string,
    file_type: string,
    token: string,
    user_id: string
): Promise<FileData | undefined> {
    try {
        const response = await backendApi.post(
            `/users/${user_id}/files`,
            {
                file_size,
                file_name,
                file_type
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status === 200) {
            const fileData: FileData = response.data.file_data;
            console.log("[fileUploadLinkRequest] response:", response.data.message);
            console.log(fileData.presigned_url)
            return fileData;
        } else {
            console.error("[fileUploadLinkRequest] unexpected status code:", response.status);
            return undefined;
        }
    } catch (error) {
        // Handle different types of errors separately
        if (axios.isAxiosError(error) && error.response) {
            // The request was made and the server responded with a status code that falls out of the range of 2xx
            console.error("[fileUploadLinkRequest] response error:", error.response.data);
        } else if (axios.isAxiosError(error) && error.request) {
            // The request was made but no response was received
            console.error("[fileUploadLinkRequest] request error:", error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error("[fileUploadLinkRequest] error:", error);
        }
        return undefined;
    }
}
// Update function for the OCR text
export async function PatchOCR(
    file_id:string,
    ocr_text:string,
    token: string,
    user_id: string
): Promise<FileData | undefined> {
    try {
        const response = await backendApi.patch(
            `/ocr/${user_id}/${file_id}`,
            {
                ocr_result:ocr_text,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status === 200) {
            const fileData: FileData = response.data.file;
            console.log("[PatchOCR] response:", response.data.message);
            // console.log(fileData)
        } else {
            console.error("[PatchOCR] unexpected status code:", response.status);
        }
    } catch (error) {
        // Handle different types of errors separately
        if (axios.isAxiosError(error) && error.response) {
            // The request was made and the server responded with a status code that falls out of the range of 2xx
            console.error("[PatchOCR] response error:", error.response.data);
        } else if (axios.isAxiosError(error) && error.request) {
            // The request was made but no response was received
            console.error("[PatchOCR] request error:", error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error("[PatchOCR] error:", error);
        }
        return undefined;
    }
}

export async function s3FileUpload(file:File | Blob,s3Link:string,file_id:string){
    console.warn(s3Link)
    const formData = new FormData();
    
    // Append the file or Blob to the FormData instance
    formData.append('file', file);

    try {
        // Perform the HTTP POST request to upload the file
        const response: AxiosResponse = await axios.put(s3Link, file,{
            headers:{
                'Content-Type':file.type
            }
        });
        return response.status===200
    } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
            // TO DO: DELETE DOCUMENT IF ERROR HAPPENS USING THE DOCUMENT ID 
            console.error('Error uploading file:', error.response?.data || error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return false
    }
}

export async function deleteFile(
    file_id: string,
    token: string,
    user_id: string
): Promise<boolean> {
    try {
        const response = await backendApi.delete(
            `/users/${user_id}/files/${file_id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status === 200) {
            console.log("[deleteFile] response:", response.data);
            return true;
        } else {
            console.error("[deleteFile] unexpected status code:", response.status);
            return false; // Added missing return
        }
    } catch (error) {
        // Handle different types of errors separately
        if (axios.isAxiosError(error) && error.response) {
            // The request was made and the server responded with a status code that falls out of the range of 2xx
            console.error("[deleteFile] response error:", error.response.data);
        } else if (axios.isAxiosError(error) && error.request) {
            // The request was made but no response was received
            console.error("[deleteFile] request error:", error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error("[deleteFile] error:", error);
        }
        return false;
    }
}